import API from "apiInstance";
import { toast } from "react-toastify";

export const uploadSingle = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/upload/single-upload",
      data: body,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
export const uploadMultiple = async (body) => {
  try {
    const response = await API({
      method: "post",
      url: "/api/upload/multi-upload",
      data: body,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
    });
    return { data: response?.data, status: response?.status };
  } catch (error) {
    toast.error(error?.message + "!");
  }
};
